import VehicleFormPage from "./VehicleFormPage";

export default function AddVehicle() {
  return <VehicleFormPage mode="add" />;
}
